import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ColorPickerModule } from "ngx-color-picker";
import { MaterialModule } from "../../../../modules/material/material.module";

import { ColorPickerComponent } from "./color-picker.component";

@NgModule({
  imports: [CommonModule, MaterialModule, ColorPickerModule],
  declarations: [ColorPickerComponent],
  exports: [ColorPickerComponent]
})
class OnsipColorPickerModule {}
export { OnsipColorPickerModule as ColorPickerModule };
